export enum IconSize {
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
}

export enum IconName {
  Alert = 'alert',
  AlertTriangle = 'alert-triangle',
  Briefcase = 'briefcase',
  BriefcaseOff = 'briefcase-off',
  BriefcaseWithAdd = 'briefcase-with-add',
  Badge = 'badge',
  Bus = 'bus',
  Calendar = 'calendar',
  Star = 'star',
  Car = 'car',
  Chat = 'chat',
  Check = 'check',
  ChevronDown = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  Child = 'child',
  Clock = 'clock',
  Close = 'close',
  CriticalError = 'critical-error',
  Crown = 'crown',
  Cube = 'cube',
  Copy = 'copy',
  Dash = 'dash',
  DoubleChevronLeft = 'double-chevron-left',
  DoubleChevronRight = 'double-chevron-right',
  Edit = 'edit',
  Hotel = 'hotel',
  Info = 'info',
  InfoCircle = 'info-circle',
  Kitchen = 'kitchen',
  Luggage = 'luggage',
  LuggageOff = 'luggage-off',
  LuggageWithAdd = 'luggage-with-add',
  More = 'more',
  Phone = 'phone',
  PlaneFilled = 'plane-filled',
  Plane = 'plane',
  Plus = 'plus',
  Refresh = 'refresh',
  Success = 'success',
  Search = 'search',
  Question = 'question',
  QuestionMark = 'question-mark',
  User = 'user',
  Walk = 'walk',
  Camera = 'camera',
  Lamp = 'lamp',
  Hours24 = '24-hours',
  Fire = 'fire',
  Pin = 'pin',
  Ski = 'ski',
  Ruble = 'ruble',
  Russian = 'russian',
  StarEmpty = 'star-empty',
  Tent = 'tent',
  Trash = 'trash',
  Flag = 'flag',
  MessageChatbot = 'message-chatbot',
  MessageDots = 'message-dots',
  Menu = 'menu',
  Key = 'key',
  Ban = 'ban',
  BoltFilled = 'bolt-filled',
  CircleCheck = 'circle-check',
  Clock72 = 'clock-72',
  ClockFilled = 'clock-filled',
  Discount = 'discount',
  PlayerTrackNext = 'player-track-next',
  RotateClockwise = 'rotate-clockwise',
  ShieldCheck = 'shield-check',
  ClockExclamation = 'clock-exclamation',
  Wrong = 'wrong',
  Bolt = 'bolt',
}
